import styled, { createGlobalStyle, css } from 'styled-components';

const StyledSelectGlobal = createGlobalStyle`
    .helix-select__menu {
        box-shadow: none;
        filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.2)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));
        ${({
  theme
}) => {
  var _a;
  return css`
            filter: ${(_a = theme === null || theme === void 0 ? void 0 : theme.select) === null || _a === void 0 ? void 0 : _a.menuFilterColor};
        `;
}}
        border-radius: 6px;
        .helix-select__option {
            font-size: 14px;
            padding: 8px;
            &.helix-select__option--is-focused,
            &:hover:not(.helix-select__option--is-disabled) {
                background-color: $helix-gray-100 !important;
                ${({
  theme
}) => {
  var _a;
  return css`
                    background-color: ${(_a = theme === null || theme === void 0 ? void 0 : theme.select) === null || _a === void 0 ? void 0 : _a.optionHoverBackgroundColor};
                `;
}}
            }
            &.helix-select__option--is-selected {
                background-color: transparent;
                color: inherit;
            }

            .helix-select__option-inner {
                display: flex;
                .helix-select__option-label {
                    flex: 1 1;
                    font-weight: 400;
                    ${({
  truncateOptions
}) => truncateOptions && css`
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        `}
                        
                }
            }
        }
        .helix-select__group {
            &:first-child {
                padding-bottom: 6px;
            }
            &:last-child {
                padding-bottom: 0px;
            }
        }
        .helix-select__group-heading {
            font-size: 14px;
            color: $helix-gray-900;
            ${({
  theme
}) => {
  var _a;
  return css`
                color: ${(_a = theme === null || theme === void 0 ? void 0 : theme.select) === null || _a === void 0 ? void 0 : _a.groupHeadingColor};
            `;
}}
            font-weight: 600;
            padding-left: 8px;
        }
    }
`;
const StyledSelect = styled.div`
    .helix-select__control {
        border-radius: 6px !important;
        border-color: ${({
  theme,
  validationType
}) => {
  var _a, _b, _c, _d, _e, _f;
  if (validationType === 'invalid') {
    return (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.red) === null || _b === void 0 ? void 0 : _b[600];
  }
  if (validationType === 'valid') {
    return (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.green) === null || _d === void 0 ? void 0 : _d[600];
  }
  return (_f = (_e = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _e === void 0 ? void 0 : _e.gray) === null || _f === void 0 ? void 0 : _f[300];
}};
        &:hover {
            border-color: ${({
  theme,
  validationType
}) => {
  var _a, _b, _c, _d, _e, _f;
  if (validationType === 'invalid') {
    return (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.red) === null || _b === void 0 ? void 0 : _b[600];
  }
  if (validationType === 'valid') {
    return (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.green) === null || _d === void 0 ? void 0 : _d[600];
  }
  return (_f = (_e = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _e === void 0 ? void 0 : _e.gray) === null || _f === void 0 ? void 0 : _f[300];
}};
        }

        ${({
  theme
}) => {
  var _a;
  return css`
            background-color: ${(_a = theme === null || theme === void 0 ? void 0 : theme.select) === null || _a === void 0 ? void 0 : _a.backgroundColor};
        `;
}}
        min-height: 36px !important;
        .helix-select__value-container {
            :last-child {
                margin-top: 0;
                padding-top: 0;
                margin-bottom: 0;
                padding-bottom: 0;
            }
        }

        .helix-select__multi-value {
            border-radius: 4px;
            ${({
  theme
}) => {
  var _a;
  return css`
                background-color: ${(_a = theme === null || theme === void 0 ? void 0 : theme.select) === null || _a === void 0 ? void 0 : _a.multiValueBackgroundColor};
            `;
}}
            margin-top: 2px;
            margin-bottom: 2px;
            .helix-select__multi-value__label {
                padding: 2px 2px 2px 6px;
                font-size: 12px;
                display: flex;
                align-items: center;
                font-weight: 700;
            }
            .helix-select__multi-value__remove {
                padding: 2px 6px 2px 2px;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                &:hover {
                    cursor: pointer;
                    background-color: inherit;
                    svg {
                        path {
                            ${({
  theme
}) => {
  var _a;
  return css`
                                fill: ${(_a = theme === null || theme === void 0 ? void 0 : theme.select) === null || _a === void 0 ? void 0 : _a.multiValueRemoveHoverColor};
                            `;
}}
                        }
                    }
                }
            }
        }
        &.helix-select__control--is-focused {
            ${({
  theme,
  validationType
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  if (validationType === 'invalid') {
    return css`
                        box-shadow: 0 0 0 1px ${(_b = (_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.red) === null || _b === void 0 ? void 0 : _b[600]};
                    `;
  }
  if (validationType === 'valid') {
    return css`
                        box-shadow: 0 0 0 1px ${(_d = (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.green) === null || _d === void 0 ? void 0 : _d[600]};
                    `;
  }
  return css`
                    border-color: ${(_f = (_e = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _e === void 0 ? void 0 : _e.blue) === null || _f === void 0 ? void 0 : _f[600]};
                    box-shadow: 0 0 0 1px ${(_g = theme === null || theme === void 0 ? void 0 : theme.select) === null || _g === void 0 ? void 0 : _g.focusedBoxShadowColor};
                `;
}}
        }

        .helix-select__placeholder {
            color: var(--helix-gray-500);
            font-weight: 400;
            font-size: 14px;
        }

        .helix-select__single-value {
            font-size: 14px;
            font-weight: 400;
        }

        .helix-select__clear-indicator {
            cursor: pointer;
            &:hover {
                svg {
                    opacity: 0.5;
                }
            }
        }
        .helix-select__dropdown-indicator {
            padding: 7px 8px 7px 1px;
        }
        .helix-select__clear-indicator {
            padding: 7px 1px 7px 8px;
        }
    }

    &.helix-select__wrapper {
        .helix-select__value-container {
            padding: 0 2px;
        }
        &.helix-select--sm {
            .helix-select__control {
                min-height: 28px !important;
                .helix-select__value-container {
                    padding: 0 2px;
                }
                .helix-select__multi-value {
                    .helix-select__multi-value__label {
                        padding: 0 2px 0 6px;
                        font-size: 12px;
                    }
                    .helix-select__multi-value__remove {
                        padding: 0 6px 0 2px;
                    }
                }
                .helix-select__placeholder,
                .helix-select__single-value {
                    font-size: 12px;
                }
                .helix-select__dropdown-indicator {
                    padding: 3px 4px 3px 1px;
                }
                .helix-select__clear-indicator {
                    padding: 3px 1px 3px 4px;
                }
                .helix-select__input-container {
                    &::after,
                    .helix-select__input {
                        height: 16px;
                    }
                }
            }
        }
        &.helix-select--lg {
            .helix-select__control {
                min-height: 46px !important;
                .helix-select__value-container {
                    padding: 7px;
                }
                .helix-select__multi-value {
                    .helix-select__multi-value__label {
                        padding: 4px 4px 4px 8px;
                        font-size: 14px;
                    }
                    .helix-select__multi-value__remove {
                        padding: 4px 8px 4px 4px;
                    }
                }
                .helix-select__placeholder,
                .helix-select__single-value {
                    font-size: 16px;
                }
            }
        }

        .helix-select__indicators {
            align-items: flex-start;
        }
    }

    &.helix-select--filled {
        .helix-select__control {
            border-radius: 0px;
            border-color: transparent;
            background-color: transparent;
            &.helix-select__control--is-focused {
                ${({
  theme
}) => {
  var _a;
  return css`
                        border-color: transparent;
                        border-bottom: 1px solid ${(_a = theme === null || theme === void 0 ? void 0 : theme.select) === null || _a === void 0 ? void 0 : _a.focusedBoxShadowColor};
                        border-radius: 0 !important;
                        box-shadow: none;
                    `;
}}
            }
        }
    }
`;

export { StyledSelect, StyledSelectGlobal };
//# sourceMappingURL=Select.styles.js.map
